import { ComponentPropsWithoutRef, forwardRef } from 'react'
import styles from '../../styles/common/Input.module.scss'

interface BaseInputProps extends ComponentPropsWithoutRef<'input'> {
  type?: string
  isError?: boolean
  className?: string
}

const BaseInput = forwardRef<HTMLInputElement, BaseInputProps>(
  (
    { type = 'text', isError = false, placeholder, className, ...props },
    ref
  ) => {
    return (
      <input
        className={`${className || ''} ${styles.container}`}
        ref={ref}
        type={type}
        placeholder={placeholder}
        {...props}
      />
    )
  }
)

BaseInput.displayName = 'BaseInput'

export default BaseInput
